// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3-vr9","options":"AnswerScale_options__HRdNP","selected":"AnswerScale_selected__2FrTx"};